import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import { buttonUpdatePassword, inputPassword } from "_constants";
import { ModalUpdatePassword } from "components/modals/ModalUpdatePassword";
import { useState } from "react";

export const PasswordContainer = () => {
  const [showModal, setShowModal] = useState(false);
  const openUpdatePasswordModal = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className="flex-container column gap-8">
        <span className="text-base-bold">{inputPassword.toUpperCase()}</span>
        <div className="p-inputgroup flex-1">
          <div className="p-inputgroup flex-1">
            <InputText placeholder="********" disabled={true} />
            <Button
              label={buttonUpdatePassword}
              severity="secondary"
              onClick={openUpdatePasswordModal}
            />
          </div>
        </div>
      </div>
      <ModalUpdatePassword
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};
